import { apiFetch } from '@/platform/lib/api';
import { publicUrlForObjectPath } from '@/platform/blog/uploads';

export const PRODUCT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const PRODUCT_IMAGE_ACCEPT = 'image/*';
export const MAX_PRODUCT_IMAGES = 8;

export async function uploadProductImage(
  file: File,
  sellerUserId: string,
  productId: string,
): Promise<string> {
  if (file.size > PRODUCT_IMAGE_MAX_BYTES) {
    throw new Error('Image must be 5 MB or smaller.');
  }
  if (!file.type.startsWith('image/')) {
    throw new Error('Only image files are allowed.');
  }

  const signed = await apiFetch<{
    uploadUrl: string;
    objectPath: string;
    publicUrl?: string;
  }>('/uploads/signed-url', {
    method: 'POST',
    body: JSON.stringify({
      purpose: 'product',
      sellerUserId,
      productId,
      filename: file.name,
      contentType: file.type || 'image/jpeg',
      sizeBytes: file.size,
    }),
  });

  if (!signed.uploadUrl.includes('signed=stub')) {
    const put = await fetch(signed.uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type || 'image/jpeg' },
    });
    if (!put.ok) {
      throw new Error('Upload failed');
    }
  }

  return signed.objectPath;
}

export function productImageDisplayUrl(objectPath: string, imageUrls?: string[], index = 0): string {
  if (imageUrls?.[index]) return imageUrls[index];
  return publicUrlForObjectPath(objectPath);
}
